import type * as core from '../../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.higherEd.gl',
    'package:data.higherEd.orgStructureSpace',
    'package:data.higherEd.research.awards',
    'package:data.higherEd.research.projects',
    'package:data.higherEd.research.sponsors',
    'package:data.higherEd.spaceUsage',
  ],
  description: 'TODO',
  name: 'Research Data - Performance',
} as const satisfies core.quiver.Package
